import { LucideImageDown } from "lucide-react";
import { useState } from "react";

const Image = ({ src, alt, className, ...props }) => {
    const [isLoading, setIsLoading] = useState(true);
    return (
        <>
            {isLoading && <div className="l-load absolute w-full h-full top-0 right-0 object-cover rounded-lg flex justify-center items-center">
                <LucideImageDown size={35} color="white" />
            </div>}
            <img
                src={src}
                alt={alt}
                className={`${!isLoading ? 'opacity-100' : 'opacity-0'} transition-opacity duration-500 ${className ? className : 'w-full h-full object-cover'}`}
                {...props}
                onLoad={() => setIsLoading(false)}
            />
        </>
    )
}
export default Image;